import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import SaudeService from '../../../../services/saude';
import { Link } from 'react-router-dom';
import Exportar from '../../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [nome, setNome] = useState("");
    const [especialidade, setEspecialidade] = useState("");

    const busca = async (query) => {
        if (query === "") {
            await props.fetchProfissionais()
            setNome("")
            setEspecialidade("")
        } else {
            var response = await SaudeService.buscarProfs(query)
            if (response.data.length >= 1) {
                props.setProfissionais(response.data)
                props.setVazio(false)
                setNome("")
                setEspecialidade("")
            } else {
                props.setVazio(true)
                setNome("")
                setEspecialidade("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (nome) prepQuery = prepQuery + `nome=${encodeURI(nome)}`;
        if (especialidade !== "false" && especialidade !== "") prepQuery = prepQuery + `&especialidade=${encodeURI(especialidade)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={3}>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Nome"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={4}>
                            <Form.Group className="mb-3" controlId="especialidade">
                                <FloatingLabel
                                    label="Especialidade"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Especialidade"
                                        name="especialidade"
                                        onChange={e => setEspecialidade(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        {props.profissionais.map((prof) =>
                                            <option value={prof.especialidade}>{prof.especialidade}</option>
                                        )}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/saude'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.profissionais} nome={"ProfissionaisSaude"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#064e0c69-b55e-4e0e-9650-4eeb5d0b1b4e" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca